import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowDown,
  faTriangleExclamation,
} from '@fortawesome/pro-light-svg-icons';
import Skeleton from '@mui/lab/Skeleton';
import IconStageCapacity from 'shared/statics/svg/icon_stage_capacity-development.svg?react';
import IconStageReach from 'shared/statics/svg/icon_stage_reach.svg?react';
import IconStageLearn from 'shared/statics/svg/icon_stage_learn.svg?react';
import IconStageAct from 'shared/statics/svg/icon_stage_act.svg?react';
import IconStageSucceed from 'shared/statics/svg/icon_stage_succeed.svg?react';
import IndicatorItem from './Components/IndicatorItem';
import styles from './IndicatorsForecastDetailsTable.module.scss';

export const WarningMsg = ({ msg }) => (
  <div className={styles.indicator__item}>
    <div className={styles.toggle__container}>
      <div className={styles.cta_icon__alert}>
        <FontAwesomeIcon icon={faTriangleExclamation} />
      </div>
    </div>
    <div className={styles.indicator__content}>
      <span className={styles.alert__empty}>
        <strong>Heads up! </strong>
        {msg}
      </span>
    </div>
  </div>
);

const IndicatorsForecastDetailsTable = ({
  stageName,
  indicators,
  handleSaveOrUpdate,
  beneficiary,
  classificationOpts,
  isLoading,
}) => {
  /*if (indicators.length === 0) {
    return null;
  }*/
  return (
    <Fragment>
      <section className={`${styles.table}`}>
        <div className={styles.table__content}>
          <div className={styles.content__row}>
            <div className={styles.stage__container}>
              <span className={`heading-label ${styles.heading__label}`}>
                Stage
              </span>
              <span className={styles.icon__container}>
                {stageName === 'Capacity Development' ? (
                  <IconStageCapacity />
                ) : stageName === 'Reach' ? (
                  <IconStageReach />
                ) : stageName === 'Learn' ? (
                  <IconStageLearn />
                ) : stageName === 'Act' ? (
                  <IconStageAct />
                ) : stageName === 'Succeed (Social Impact)' ? (
                  <IconStageSucceed />
                ) : (
                  ''
                )}
              </span>
              <span className={`heading ${styles.card__heading}`}>
                {stageName}
              </span>
              <span className={styles.next_icon}>
                {stageName !== 'Succeed (Social Impact)' ? (
                  <FontAwesomeIcon icon={faArrowDown} />
                ) : (
                  ''
                )}
              </span>
            </div>
            <div className={styles.indicator__wrapper}>
              {isLoading && (
                <div style={{ width: '100%', marginTop: '20px' }}>
                  <Skeleton />
                  <Skeleton width="80%" />
                  <Skeleton width="80%" />
                </div>
              )}
              {!isLoading && (!indicators || indicators.length === 0) && (
                <WarningMsg msg={'You have not selected any indicators for this stage, to add indicators, review your impact model ' +
                  'builder'} />
              )}
              {indicators.map(ind => (
                <IndicatorItem
                  id={ind.dbId}
                  resultId={ind.resultId}
                  indicatorName={ind.name}
                  indicatorForecast={ind.forecast}
                  indicatorDefinition={ind.definition}
                  indicatorMeasured={ind.classification}
                  indicatorMeans={ind.description}
                  indicatorTracking={ind?.tracking}
                  handleSaveOrUpdate={handleSaveOrUpdate}
                  beneficiary={beneficiary}
                  classificationOpts={classificationOpts}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default IndicatorsForecastDetailsTable;
